
export function isInventoryAccessDeniedError(error: unknown): boolean {
    const code = (error as { response?: { data?: { code?: string } } })?.response?.data?.code;
    return code === 'INVENTORY_ACCESS_DENIED';
}
